import React, { createContext, useState } from 'react';

const MenuContext = createContext( true );

export const MenuProvider = ( { children } ) =>
{
    const [ menuisopen, setMenuisopen ] = useState( true );

    return (
        <MenuContext.Provider value={ { menuisopen, setMenuisopen } }>
            { children }
        </MenuContext.Provider>
    );
};

export default MenuContext;
